import fr from "./fr"
import uk from "./uk"
import nl from "./nl"

export default {
    nl, uk, fr
}